import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import getPath from 'lodash/get';
import range from 'lodash/range';
import { useSelector, useDispatch } from 'react-redux';
import { fetchManagedSoundcastRatingsOverviewCreator } from '../../../../routines';
import { FlexDiv, FlexiRow } from '../../../../styles/styled';
import RatingBar from './RatingBar';

const Overview = props => {
  const { soundcast } = props;

  if (isEmpty(soundcast)) {
    return null;
  }

  const { soundcastId } = soundcast;
  const dispatch = useDispatch();
  const overview = useSelector(store => getPath(store, `ratings.overview.${soundcastId}`, {}));

  useEffect(() => {
    if (!isEmpty(soundcast) && isEmpty(overview)) {
      fetchManagedSoundcastRatingsOverviewCreator({ soundcastId }, dispatch);
    }
  }, [soundcast]);

  const getRatingsStats = ({ ratings = [] }) => {
    if (isEmpty(ratings)) {
      return range(5)
        .reverse()
        .map(stars => ({ stars: stars + 1, percentage: 0, total: 0 }));
    }

    return ratings;
  };

  const { average = 0, total = 0 } = overview;
  return (
    <FlexiRow className="row" alignItems="center">
      <div className="col-lg-12">
        <FlexDiv alignItems="center">
          <div className="padding-30px-lr text-center">
            <div className="title-small font-weight-600">{average}</div>
            <div className="text-large">out of 5</div>
          </div>
          <div className="padding-30px-lr">
            {getRatingsStats(overview).map((rating, i) => {
              return (
                <RatingBar
                  key={i}
                  stars={rating.stars}
                  percent={Number(rating.percentage).toFixed(0)}
                />
              );
            })}
          </div>
          <div className="padding-30px-lr text-center">
            <div className="title-small font-weight-600">{total}</div>
            <div className="text-large">Rating{total > 1 ? 's' : ''}</div>
          </div>
        </FlexDiv>
      </div>
    </FlexiRow>
  );
};

Overview.propTypes = {
  soundcast: PropTypes.object,
};

Overview.defaultProps = {
  soundcast: {},
};

export default React.memo(Overview);
